export const genericSourceDataSelector = ({ shared }) =>
  shared.genericSourceData.genericSourceData.genericSourceData;
export const genericSourceDataColumnsSelector = ({ shared }) =>
  shared.genericSourceData.genericSourceData.genericSourceDataColumns;
export const genericSourceDataScreenTitleSelector = ({ shared }) =>
  shared.genericSourceData.genericSourceData.screenTitle;
export const isFetchingGenericSourceDataSelector = ({ shared }) =>
  shared.genericSourceData.isFetchingGenericSourceData;
